<template>
  <div :class="{'toolClass': status===2, '':status===0}">
    <timeStampDatePicker
      split-panels
      v-model="date"
      :editable='editable'
      :options='option'
      @input='handleInput'
      placeholder="请选择"
      :size='size'
      :disabled='forever'
      :type="isRange ? 'daterange' : 'date'"
      v-if="able"
      :class="{'hasForever':hasForever,'noForever':!hasForever}"
      ></timeStampDatePicker>
      <div v-else>
      <span :class="status === 2 ? 'expiredDate' : ''">{{dateTimeString}}</span>
      <lk-icon v-if="expireDate" class='expireIcon' type="md-warning" :color='color' size=16></lk-icon>
    </div>
    <lk-checkbox class="isForever" v-if="hasForever && able" v-model="forever" @on-change='handleForever'>长期有效</lk-checkbox>
    <div class="expireInfo" v-if="expireDate">{{expireDate}}</div>
  </div>
</template>
<script>
import utils from '../../libs/utils.js';
import timeStampDatePicker from '../timeStampDatePicker.vue';

export default {
  name: 'expirePicker',
  components: { timeStampDatePicker },
  props: {
    disableInfo: { // 禁用过期提示
      type: Boolean,
      default: false,
    },
    able: { // 编辑还是查看
      type: Boolean,
      default: false,
    },
    value: {
    },
    editable: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
    },
    size: {
      type: String,
      default: 'default',
    },
    type: { // 过期类型 30天还是180天
      type: Number,
      default: 0,
    },
    hasForever: { // 有无 长期有效
      type: Boolean,
      default: false,
    },
    isForever: { // 是否 长期
      type: Boolean,
      default: false,
    },
    msg: {
      type: String,
      default: '',
    },
    isRange: { // 是否是time range
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  watch: {
    // date() {
    //   console.log(this.date);
    // },
    isForever() {
      this.forever = this.isForever;
    },
    value: {
      handler(val) {
        // console.log(123123);
        // if (Object.prototype.toString.call(val) === '[object Array]') {
        //   if (val.length) {
        //     const temp = utils.deepClone(val);
        //     temp[0] = new Date(temp[0]);
        //     temp[1] = new Date(temp[1]);
        //   }
        //   this.date = val;
        // } else {
        //   this.date = val ? new Date(val) : null;
        // }
        this.date = val;
        this.expireInfoTitp(val, this.isForever);
      },
      deep: true,
    },
  },
  data() {
    return {
      ready: false,
      date: null,
      forever: false,
      status: 0, // 0 正常 1即将过期 2已过期
      expireDate: '', // tooltip文案
      expireType: [30, 180, 90], // 过期时间 30天或180天 通过type判断
      color: '', // icon 颜色
      dateTimeString: '', // 用于查看展示的日期
      option: {},
    };
  },
  methods: {
    dispatch(componentName, eventName, params) { // 强制触发form方法
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    handleForever(val) {
      const temp = this.isRange ? [] : '';
      this.handleInput(temp);
      this.$emit('handleForever', val);
    },
    handleInput(val) {
      if (!this.ready) {
        return;
      }
      // console.log(val);

      this.expireInfoTitp(val, this.isForever);
      if (Object.prototype.toString.call(val) === '[object Array]') {
        if (!val[0]) {
          this.$emit('change', []);
          this.dispatch('FormItem', 'on-form-change', []);
          this.date = [];
        } else {
          const temp = val;

          this.$emit('change', temp);
          this.dispatch('FormItem', 'on-form-change', temp);
        }
      } else {
        const res = val || null;
        this.$emit('change', res);
        this.dispatch('FormItem', 'on-form-change', res);
      }
    },
    handleRange(val, years) {
      console.log(val);

      if (!val.rangeState.from) {
        this.$Message.error('请选择开始日期！');
        return;
      }
      const start = val.rangeState.from;
      const all = years;
      let isRun = 0;
      const month = start.getMonth() + 1;
      let startPosition = 0;
      if (month < 3) {
        if (month === 2 && start.getDate() === 29) {
          startPosition = 1;
        }
      } else {
        startPosition = 1;
      }
      for (let i = startPosition; i < (startPosition + all); i++) {
        const year = start.getFullYear() + i;
        if (year % 100 === 0 && year % 400 === 0) {
          isRun++;
        } else if (year % 4 === 0) {
          isRun++;
        }
      }
      const end = start.getTime() + 3600 * 1000 * 24 * (366 * isRun + (all - isRun) * 365 - 1);
      this.$emit('handle', [start.getTime(), end]);
      this.date = [start.getTime(), end];

      this.handleInput(this.date);
    },
    expireInfoTitp(val, isForever) {
      if (isForever) {
        this.dateTimeString = '长期';
        return;
      }

      if (val) {
        let overTime = 0;
        if (Object.prototype.toString.call(val) === '[object Array]') {
          if (val[1]) {
            this.dateTimeString = `${utils.exchangeTime(val[0])}至${utils.exchangeTime(val[1])}`;
            overTime = new Date(new Date(val[1]).toLocaleDateString()).getTime() + 86399999 - (new Date()).getTime(); // +86399999 当天不算过期
          } else {
            this.expireDate = '';
          }
        } else {
          this.dateTimeString = utils.exchangeTime(val);
          overTime = new Date(new Date(val).toLocaleDateString()).getTime() + 86399999 - (new Date()).getTime();
        }

        if (overTime < 0) {
          this.expireDate = `${this.msg}已过期，请及时更新`;
          this.color = '#FF4D07';
          this.status = 2;
        } else {
          const overDays = overTime / (24 * 3600 * 1000);
          if (overDays < this.expireType[this.type] && overDays !== 0) {
            this.expireDate = `${this.msg}即将过期，请及时更新`;
            this.color = '#FF4D07';
            this.status = 1;
          } else {
            this.expireDate = '';
            this.status = 0;
          }
        }
      } else {
        this.expireDate = '';
      }
      if (this.disableInfo) {
        // this.dateTimeString = '';
        this.expireDate = '';
        this.status = 0;
      }
    },
  },
  mounted() {
    this.ready = true;
    this.expireInfoTitp(this.value, this.isForever);
    // if (Object.prototype.toString.call(this.value) === '[object Array]') {
    //   this.date = this.value;
    // } else {
    //   }
    this.date = this.value || null;
    console.log(this.value);
    console.log(this.date);

    this.forever = this.isForever;
    console.log(this.isRange);
    if (this.isRange) {
      this.option = {
        shortcuts: [
          { text: '1 年', onClick: (val) => { this.handleRange(val, 1); } },
          { text: '5 年', onClick: (val) => { this.handleRange(val, 5); } },
          { text: '10 年', onClick: (val) => { this.handleRange(val, 10); } },
          { text: '20 年', onClick: (val) => { this.handleRange(val, 20); } },
          { text: '30 年', onClick: (val) => { this.handleRange(val, 30); } },
        ],
      };
    }
    if (this.options) {
      this.option = this.options;
    }
    console.log(this.option);
  },
};
</script>
<style lang="less" scoped>
.flex{
  display: flex
}
.forever{
  width: 70px;
  margin: 0
}
.hasForever{
  width:calc(~'100% - 82px');
  margin-right: 8px
}
.expiredDate{
  color: #FF4D07;
}
.expireIcon{
  margin-bottom: 3px;
  margin-left: 8px;
}
.noForever{
  width: 100%;
}
.expireInfo{
  color: #FF4D07;
  line-height: 1;
      position: absolute;
    top: 100%;
    left: 0;
}
</style>
